import React from 'react';
import { PackageOpen } from 'lucide-react';

// >=150 Excess (green) | >=125 OK (yellow) | >=100 Warning (orange) | <100 Critical (red)
const getCriticalityStyles = (stockCriticality) => {
    const val = Number(stockCriticality) ?? 0;
    if (val >= 150) return { dot: 'bg-green-500', status: 'Excess', statusClass: 'text-green-600' };
    if (val >= 125) return { dot: 'bg-yellow-500', status: 'OK', statusClass: 'text-yellow-600' };
    if (val >= 100) return { dot: 'bg-orange-500', status: 'Warning', statusClass: 'text-orange-600' };
    return { dot: 'bg-red-500', status: 'Critical', statusClass: 'text-red-600' };
};

const MaterialStatus = ({ materials }) => {
    const items = Array.isArray(materials) ? materials : [];
    const criticalItems = items.filter((item) => (Number(item.stock_criticality) ?? 0) < 100);

    return (
        <div className="bg-white rounded-2xl p-6 shadow-md h-full relative">
            <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-bold text-gray-900 leading-tight ">Material & Inventory Signals</h3>
                {/* {criticalItems.length > 0 && (
                    <span className="border border-red-500 text-red-600 text-[10px] px-1 py-0.5 rounded font-medium">Emergency</span>
                )} */}
            </div>

            <div className="flex flex-col gap-4">
                {items.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
                        <PackageOpen className="w-12 h-12 text-gray-300 mb-3" strokeWidth={1.25} aria-hidden />
                        <p className="text-sm font-medium text-gray-600 mb-1">No material stats for this week</p>
                        <p className="text-xs text-gray-500">Select a project and report week to see used vs estimated quantities and stock signals.</p>
                    </div>
                ) : (
                    items.map((item) => {
                        const criticality = getCriticalityStyles(item.stock_criticality);
                        const estimated = item.estimated ?? 0;
                        const used = item.used ?? 0;
                        const unit = (item.unit || '').trim();
                        const countText = unit ? `${used} / ${estimated} ${unit}` : `${used} / ${estimated}`;
                        return (
                            <div key={item.itemId ?? item.itemName} className="flex justify-between items-start border-l-2 border-transparent pl-2 relative">
                                <div className="flex flex-col">
                                    <div className="flex items-center gap-2">
                                        <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${criticality.dot}`} />
                                        <span className="text-sm font-medium text-gray-900">{item.itemName}</span>
                                    </div>
                                    <span className="text-xs text-gray-400 pl-3.5">{countText}</span>
                                </div>
                                <span className={`text-[10px] uppercase font-bold ${criticality.statusClass}`}>
                                    {criticality.status}
                                </span>
                            </div>
                        );
                    })
                )}
            </div>

            {/* {criticalItems.length > 0 && (
                <div className="mt-6 pt-4 border-t border-gray-200">
                    <p className="text-[10px] text-gray-900">
                        <span className="text-red-600 font-bold">Emergency / low stock:</span>{' '}
                        {criticalItems.map((i) => i.itemName).join(', ')}
                    </p>
                </div>
            )} */}
        </div>
    );
};

export default MaterialStatus;
